import { ISeoMetaData } from '.'

export const msaSeoMetaData: ISeoMetaData[] = [
  {
    path: '/claims/msa',
    seo: {
      en: {
        title: 'Medicare Set Aside (MSA) Cases | Medicare',
        description: ''
      },
      es: {
        title: 'Casos de cantidad estipulada separada para gastos de Medicare (MSA) | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/claims/msa/disclaimer',
    seo: {
      en: {
        title: 'Medicare Set Aside (MSA) Disclaimer | Medicare',
        description: ''
      },
      es: {
        title: 'Descargo de responsabilidad de cantidad estipulada separada para gastos de Medicare (MSA) | Medicare',
        description: ''
      }
    }
  }
].map(seoMetaData => ({
  ...seoMetaData,
  component: 'Medicare Set Aside'
}))
